import { render, staticRenderFns } from "./transferisimlistesi.vue?vue&type=template&id=a42c3d04&"
import script from "./transferisimlistesi.vue?vue&type=script&lang=js&"
export * from "./transferisimlistesi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports